module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "otherfm1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("Other books by John P. Schuster")]), _vm._v(" "), _c('p', {
    staticClass: "indentv"
  }, [_c('em', [_vm._v("Answering Your Call: A Guide to Living Your Deepest Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "indentv"
  }, [_c('em', [_vm._v("The Power of Open-Book Management")])]), _vm._v(" "), _c('p', {
    staticClass: "indentv"
  }, [_c('em', [_vm._v("The Open-Book Management Field Book")])]), _vm._v(" "), _c('p', {
    staticClass: "indentv"
  }, [_c('em', [_vm._v("From Hum-Drum to Hot-Diggity on Leadership")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f2e618","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm1.vue
// module id = 63
// module chunks = 0